import {Injectable} from '@angular/core';
import {MedicalRecordProblemModel} from '../../api/model/medicalRecordProblem.model';
import {MedicalProblemRepository} from './ngrx/medicalProblem.repository';
import {MedicalProblemDataServiceAdapter} from './ngrx/medicalProblemDataService.adapter';
import {AbstractFindOneByIdService} from '../../../../../core/service/v2/service/findone/abstractFindOneById.service';

@Injectable()
export class MedicalProblemFindOneByIdService extends AbstractFindOneByIdService<MedicalRecordProblemModel, MedicalRecordProblemModel> {

    constructor(private service: MedicalProblemRepository,
                dataService: MedicalProblemDataServiceAdapter) {
        super(service, dataService);
    }
}